// @flow
import * as React from 'react';
import { isEmpty } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'translations';
import SelectorButton from 'mz-ui-kit/core/SelectorButton';
import Button from 'mz-ui-kit/core/Button';
import { updateSearchFilter } from 'app/actions/search-results';
import { getActiveSearchFilters } from 'app/sagas/selectors';
import { EMPTY_FILTER } from 'app/reducers/search-results';
import { Badge } from './elements';
import FiltersForm from '../FiltersForm';
import posthog from 'posthog-js';

const messages = {
  filters: { id: 'SEARCH_RESULTS.FILTERS' },
};

const captureEvent = (filters = {}) => {
  const filterKeys = [
    'suitcaseCount',
    'supplierScore',
    'meetAndGreet',
    'green',
    'vehicleClass',
  ];

  const selected_filters = Object.entries(filters)
    .filter(([key, value]) => filterKeys.includes(key) && Boolean(value))
    .map(([key]) => key);

  const filter_count = selected_filters.length;

  posthog.capture('Results Filtered', {
    selected_filters,
    filter_count,
  });
};

/**
 * Filters, apply Meet & Greet and Suitcase number filter to search results
 * @return React.Node
 */
function FiltersSelectorButton() {
  const reduxDispatch = useDispatch();
  const activeFilters = useSelector(getActiveSearchFilters);
  const enabledFilters = Object.keys(activeFilters).filter(
    (k) => k !== 'sort' && !isEmpty(activeFilters[k])
  ).length;

  const applyFilters = (close) => (filters) => {
    captureEvent(filters);
    reduxDispatch(updateSearchFilter(filters));
    close();
  };
  

  return (
    <SelectorButton
      mobileTitle={<FormattedMessage {...messages.filters} />}
      renderButton={({ open }) => (
        <Button color="secondary" onClick={open}>
          <FormattedMessage {...messages.filters} />
          {enabledFilters > 0 ? <Badge>{enabledFilters}</Badge> : null}
        </Button>
      )}
      width="280px"
      renderSelector={({ close }) => (
        <FiltersForm
          onApplyChanges={applyFilters(close)}
          initFilters={activeFilters}
          emptyFilters={EMPTY_FILTER}
        />
      )}
    />
  );
}

export default FiltersSelectorButton;
